<template>
  <div>
    <div class="air__utils__scrollTable mb-4 px-4">
      <button
          type="button"
          @click="openCreatePricingRuleModal()"
          class="btn btn-primary btn-with-addon mr-auto text-nowrap d-none d-md-block"
        >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
          Nieuwe regel toevoegen
        </button>

        <a-modal
            id="modal-1"
            title="Nieuwe prijstabel regel"
            v-model="createPricingRuleModal"
            @ok="createPricingRule()"
          >
            <a-form layout="inline">
              <a-form-item label="Vanaf dag">
                <a-input placeholder="dag" v-model="min_days"/>
              </a-form-item>
              <a-form-item label="Prijs per dag">
                <a-input placeholder="prijs" v-model="price_per_day"/>
              </a-form-item>
              <a-form-item label="Start prijs">
                <a-input placeholder="prijs" v-model="start_price"/>
              </a-form-item>
              <b-toast id="pricingrule-created" variant="primary" title="Prijstabellen" >
                <i class="fe fe-plus-circle mr-2" />Regel aangemaakt
              </b-toast>
              <b-toast id="something-went-wrong" variant="danger" title="Kortingscode">
                <i class="fe fe-alert-octagon mr-2" />Er ging iets fout
              </b-toast>
            </a-form>
          </a-modal>
          <a-modal
            id="modal-1"
            title="Nieuwe prijstabel regel"
            v-model="createPricingRuleModal"
            @ok="editPricingRule()"
          >
            <a-form layout="inline">
              <a-form-item label="Vanaf dag">
                <a-input placeholder="dag" v-model="min_days"/>
              </a-form-item>
              <a-form-item label="Prijs per dag">
                <a-input placeholder="prijs" v-model="price_per_day"/>
              </a-form-item>
              <a-form-item label="Start prijs">
                <a-input placeholder="prijs" v-model="start_price"/>
              </a-form-item>
              <b-toast id="pricingrule-created" variant="primary" title="Prijstabellen" >
                <i class="fe fe-plus-circle mr-2" />Regel aangemaakt
              </b-toast>
              <b-toast id="something-went-wrong" variant="danger" title="Kortingscode">
                <i class="fe fe-alert-octagon mr-2" />Er ging iets fout
              </b-toast>
            </a-form>
          </a-modal>
        <div v-if="priceTableLoad"  class="w-100 d-flex justify-content-center align-items-center">
          <a-spin size="large" />
        </div>
      <a-table
      v-else
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
      >
        <!--        <template slot="avatar" slot-scope="link">-->
        <!--          <div class="air__utils__avatar">-->
        <!--            <img :src="link" alt="User" />-->
        <!--          </div>-->
        <!--        </template>-->
        <template slot="min_days" slot-scope="min_days">
          <div>
            <div>{{min_days}}</div>
<!--            <div class="text-gray-4">{{first_name}}</div>-->
          </div>
        </template>
        <template slot="price_per_day" slot-scope="price_per_day">
          <div>
            <div>{{price_per_day}}</div>
            <!--            <div class="text-gray-4">{{first_name}}</div>-->
          </div>
        </template>
        <template slot="start_price" slot-scope="start_price">
          <div>
            <div>{{start_price}}</div>
            <!--            <div class="text-gray-4">{{first_name}}</div>-->
          </div>
        </template>

        <template slot="action">
          <div>
            <button type="button" class="btn btn-primary mr-2">
              <i class="fe fe-plus-circle" />
            </button>
            <button type="button" class="btn btn-light">
              <i class="fe fe-settings text-blue" />
            </button>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    dataIndex: 'min_days',
    title: 'Vanaf dag',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'min_days' },
  },
  {
    dataIndex: 'price_per_day',
    title: 'Prijs per dag',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'price_per_day' },
  },
  {
    dataIndex: 'start_price',
    title: 'Start prijs',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'start_price' },
  },

  {
    dataIndex: 'action',
    className: 'bg-transparent text-right',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'ReservationsAll',
  props: ['organization_id'],
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data: function() {
    return {
      columns,
      data: [],
      createPricingRuleModal: false,
      priceTableLoad: true,
    }
  },
  mounted() {
    this.getPriceTables()
  },
  methods: {
    openCreatePricingRuleModal() {
      this.createPricingRuleModal = true
    },
    getPriceTables() {
      this.priceTableLoad = true
      this.$axios.get(`/pricetable/list`, { params: {
        organization_id: this.organization_id ? this.organization_id : undefined,
      },
      headers: {
        'Authorization': `Bearer ${this.user.user.token}`,
      } }).then(response => {
        this.priceTableLoad = false
        this.data = response.data
      })
    },
    createPricingRule() {
      this.$axios.post(`/pricetable/new`, {
        organization_id: this.organization_id ? this.organization_id : undefined,
        min_days: this.min_days,
        price_per_day: this.price_per_day,
        start_price: this.start_price,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.getPriceTables()
        this.min_days = undefined
        this.price_per_day = undefined
        this.start_price = undefined
        this.createPricingRuleModal = false
        this.$bvToast.show('pricingrule-created', { toaster: 'b-toaster-top-right' })
      }).catch(error => {
        this.$bvToast.show('something-went-wrong', { toaster: 'b-toaster-top-right' })
        console.log(error)
      })
    },
  },
}
</script>
